<template>
    <div class="web-home">
        <!-- 1、logo部分 -->
        <div class="web-home-logo"></div>
        <!-- 2、搜索框部分 -->
        <div class="web-home-search-box">
            <web-search-input></web-search-input>
        </div>
        <!-- 3、列表部分 -->
        <div class="web-home-list dsp-flex">
            <div class="web-home-list-hot">
               <div class="web-home-list-title">热门名人<span class="list-more" @click="clickCheckMore(1)">更多&gt;</span></div> 
               <div class="web-home-list-hot-list">
                   <div class="web-home-list-item" v-for="(hotData, index) of hotList" v-bind:key="'hot' + hotData.id" @click="clickItem(hotData)">
                       <span class="web-home-list-item-num " v-bind:class="'num-'+(index+1)">{{index+1}}</span>{{hotData.name}}
                    </div>
               </div>
               <!-- <div class="web-home-list-more"><span @click="clickCheckMore(1)" class="more">查看更多&gt;</span></div> -->
            </div>
            <div class="web-home-list-new">
                <div class="web-home-list-title">最新创建<span class="list-more" @click="clickCheckMore(2)">更多&gt;</span></div> 
                <div class="web-home-list-new-list dsp-flex">
                    <div class="web-home-list-new-list-1">
                        <div class="web-home-list-item" v-for="(newData1, index1) of newList1" v-bind:key="'new' + newData1.id" @click="clickItem(newData1)">
                            <span class="web-home-list-item-num">{{index1+1}}</span>{{newData1.name}}
                        </div>
                    </div>
                    <div class="web-home-list-new-list-2">
                        <div class="web-home-list-item" v-for="(newData2, index2) of newList2" v-bind:key="'new' + newData2.id" @click="clickItem(newData2)">
                            <span class="web-home-list-item-num">{{index2+4}}</span>{{newData2.name}}
                        </div>
                    </div>
                </div>
                <!-- <div class="web-home-list-more"><span @click="clickCheckMore(2)" class="more">查看更多&gt;</span></div> -->
            </div>
        </div>
        <!-- 4、copyright -->
        <web-copy-right></web-copy-right>
    </div>
</template>

<script>
import WebSearchInput from '../../components/web/WebSearchInput.vue'
import WebCopyRight from '../../layouts/web/WebCopyRight.vue'
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { LOADING_DOM } from '../../modules/dom';
import { CONFIG } from '../../modules/config';
import { SHARE } from '../../modules/share';
export default {
    name: 'WebHome',
    components: { WebSearchInput, WebCopyRight },
    computed: {
        hotPediaList() {
            return this.$store.state.famouspedia.hotPediaList;
        },
        newPediaList() {
            return this.$store.state.famouspedia.newPediaList;
        }
    },
    data() {
        return {
            locked: false,
            hotList: [],
            newList1: [],
            newList2: []
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
            SHARE.initConfigShare();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.height = (innerHeight - 40) + 'px';
        },
        initData() {
            var me = this,
                gotHotList = this.$store.state.famouspedia.gotHotList,
                gotNewList = this.$store.state.famouspedia.gotNewList;
            if(!gotHotList) {
                this.$store.dispatch('famouspedia/initHotList', {
                    cb: function() {
                        me.initHotList();
                    }
                });
            }else {
                me.initHotList();
            }
            if(!gotNewList) {
                this.$store.dispatch('famouspedia/initNewList', {
                    cb: function() {
                        me.initNewList();
                    }
                });
            }else {
                me.initNewList();
            }
        },
        initHotList() {
            var templist = [].concat(this.hotPediaList);
            this.hotList = templist.splice(0, 3);
        },
        initNewList() {
            var templist = [].concat(this.newPediaList);
            this.newList1 = templist.splice(0, 3);
            this.newList2 = templist.splice(0, 3);
        },
        clickItem(data) {
            var me = this;
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                me.locked = false;
            }, 2000);
            LOADING_DOM.showLoading();

            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: data.id,
                baikeType: data.type,
                baikeStatus: data.status,
                sucCb: function(curEditType) {
                    me.locked = false;
                    if(curEditType == CONST_FAMOUS_PEDIA_EDIT_TYPE.read) {
                        setTimeout(() => {
                            me.$router.replace('/famouspediareadweb/' + data.id + '/famouspedia')
                        }, 20);
                    }else {
                        me.$router.replace('/famouspediaedit')
                    }
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.locked = false;
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            })
        },
        clickCheckMore(num) {
            this.$store.state.famouspedia.curPediaMenuId = num;
            this.$router.replace('/famouspediatwo');
        },
    }
}
</script>